import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { useParams, useHistory } from "react-router-dom";
import userDetails, { getUserRole } from "../../services/userTokenDetails";
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import { Toast } from 'primereact/toast';

const QrScan = () => {
    let emptyparticipant = {
        id: '',
        serialNo: '',
        fullName: '',
        isarrived: '',
        ischeckedin: '',
        ispresent: '',
        dayTwoPresent: '',
        mobileno: '',
        email: ''
    };
    const history = useHistory();
    const [participantdata, setparticipantdata] = useState(emptyparticipant);
    const [SuccessDialog, setSuccessDialog] = useState(false);
    const [AirportWarningDialog, setAirportWarningDialog] = useState(false);
    const [HotelWarningDialog, setHotelWarningDialog] = useState(false);
    const [VenueWarningDialog, setVenueWarningDialog] = useState(false);
    const [ErrorDialog, setErrorDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isDayTwo, setIsDayTwo] = useState(false);

    let EventDayOneDt = null;
    let EventDayTwoDt = null;

    const param = useParams();
    const toast = useRef(null);
    const usrDetails = userDetails();
    const userRole = (usrDetails && usrDetails.role) || getUserRole() || localStorage.getItem("userRole") || "";
    const UserName = localStorage.getItem("Username") || "";

    useEffect(() => {
        if (param.id && param.id !== '') {
            getHeaders(param.id);
        } else {
            setErrorMessage('Invalid QR Code: Participant ID is missing.');
            setErrorDialog(true);
        }
    }, [param.id]);

    //#region Get Header/config file details
    const getHeaders = (id) => {
        fetch('/config.json', {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                if (Array.isArray(data)) {
                    const dayOneObj = data.find(item => item && item.EventDayOneDt !== undefined);
                    const dayTwoObj = data.find(item => item && item.EventDayTwoDt !== undefined);
                    EventDayOneDt = dayOneObj ? dayOneObj.EventDayOneDt : (data[9]?.EventDayOneDt || null);
                    EventDayTwoDt = dayTwoObj ? dayTwoObj.EventDayTwoDt : (data[10]?.EventDayTwoDt || null);
                }
                getparticipantDetailsbyid(id);
            })
            .catch(function (error) {
                console.warn('Failed to load config.json:', error);
                getparticipantDetailsbyid(id);
            });
    };
    //#endregion

    const getparticipantDetailsbyid = (id) => {
        setIsLoading(true);
        axios.get('/api/Participant/GetParticipantById/' + id)
            .then((Response) => {
                setIsLoading(false);
                if (!Response.data) {
                    setErrorMessage('Participant record not found.');
                    setErrorDialog(true);
                    return;
                }
                let _participant = { ...Response.data };
                _participant['id'] = Response.data.id || id;
                // Capture only the actual Serial Number / Card No value, do not fall back to GUID
                const serialVal = Response.data.serialNumber || Response.data.SerialNumber || Response.data.cardNo || Response.data.CardNo || Response.data.serialNo || '';
                _participant['serialNo'] = serialVal ? String(serialVal) : '';
                _participant['fullName'] = Response.data.fullName || `${Response.data.firstname || ''} ${Response.data.lastname || ''}`.trim();
                _participant['company'] = Response.data.company || Response.data.companyName || Response.data.companyname || Response.data.hospitalName || Response.data.hospitalname || '';
                _participant['designation'] = Response.data.designation || Response.data.Designation || '';
                _participant['speciality'] = Response.data.speciality || Response.data['speciality '] || Response.data.Speciality || '';
                _participant['qualification'] = Response.data.qualification || Response.data.Qualification || '';
                _participant['statename'] = Response.data.statename || Response.data.stateName || Response.data.StateName || '';
                _participant['countryname'] = Response.data.countryname || Response.data.countryName || Response.data.CountryName || '';
                _participant['mobileno'] = Response.data.mobileNo || '';
                _participant['email'] = Response.data.email || '';
                _participant['ispresent'] = Response.data.present;
                _participant['dayTwoPresent'] = Response.data.dayTwoPresent;
                _participant['ischeckedin'] = Response.data.isCheckedIn;
                _participant['isarrived'] = Response.data.isArrived;
                setparticipantdata(_participant);
                checkAndUpdateParticipantRecord(Response.data.present, Response.data.dayTwoPresent, Response.data.isCheckedIn, Response.data.isArrived);
            })
            .catch((error) => {
                setIsLoading(false);
                setErrorMessage('Oops! Unable to find participant or something went wrong.');
                setErrorDialog(true);
                if (toast.current) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Oops! Something Went Wrong!', life: 3000 });
                }
            });
    };

    const checkAndUpdateParticipantRecord = (Present, DayTwoPresent, CheckedIn, Arrived) => {
        const currentDT = new Date();
        const eventDayTwoDT = EventDayTwoDt ? new Date(EventDayTwoDt) : null;
        const dayTwoDatesEqual = eventDayTwoDT &&
            currentDT.getFullYear() === eventDayTwoDT.getFullYear() &&
            currentDT.getMonth() === eventDayTwoDT.getMonth() &&
            currentDT.getDate() === eventDayTwoDT.getDate();

        setIsDayTwo(!!dayTwoDatesEqual);

        if (userRole === "AIRPORT CO-ORDINATOR") {
            UpdateAirportRecord(Arrived);
        } else if (userRole === "HOTEL CO-ORDINATOR") {
            UpdateHotelRecord(CheckedIn);
        } else {
            // VENUE CO-ORDINATOR, ADMIN, ITADMIN or default
            if (dayTwoDatesEqual) {
                UpdateDay1Day2Present(DayTwoPresent, false, true);
            } else {
                UpdateDay1Day2Present(Present, true, false);
            }
        }
    };

    const UpdateAirportRecord = (Arrived) => {
        if (!Arrived) {
            axios.put('/api/Participant/UpdateParticipantOnQrScan', {
                id: param.id,
                IsArrived: true,
                AirportScannedBy: UserName
            })
                .then(res => {
                    setSuccessDialog(true);
                }).catch((error) => {
                    setIsLoading(false);
                    const msg = error?.response?.data?.message || (typeof error?.response?.data === 'string' ? error.response.data : 'Failed to update Airport check-in status.');
                    setErrorMessage(msg);
                    setErrorDialog(true);
                    if (toast.current) {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Oops! Something Went Wrong!', life: 3000 });
                    }
                });
        } else {
            setAirportWarningDialog(true);
        }
    };

    const UpdateHotelRecord = (CheckedIn) => {
        if (!CheckedIn) {
            axios.put('/api/Participant/UpdateParticipantOnQrScan', {
                id: param.id,
                IsCheckedIn: true,
                HotelScannedBy: UserName
            })
                .then(res => {
                    setSuccessDialog(true);
                }).catch((error) => {
                    setIsLoading(false);
                    const msg = error?.response?.data?.message || (typeof error?.response?.data === 'string' ? error.response.data : 'Failed to update Hotel check-in status.');
                    setErrorMessage(msg);
                    setErrorDialog(true);
                    if (toast.current) {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Oops! Something Went Wrong!', life: 3000 });
                    }
                });
        } else {
            setHotelWarningDialog(true);
        }
    };

    const UpdateDay1Day2Present = (Present, DayOne, DayTwo) => {
        if (!Present) {
            if (DayOne) {
                makeParticipantDayOnePresent(param.id, UserName);
            } else if (DayTwo) {
                makeParticipantDayTwoPresent(param.id, UserName);
            }
        } else {
            setVenueWarningDialog(true);
        }
    };

    const makeParticipantDayOnePresent = (Id, UserName) => {
        axios.put('/api/Participant/UpdateParticipantOnQrScan', {
            id: Id,
            Present: true,
            VenueDay1ScannedBy: UserName
        })
            .then(res => {
                setSuccessDialog(true);
            }).catch((error) => {
                setIsLoading(false);
                const msg = error?.response?.data?.message || (typeof error?.response?.data === 'string' ? error.response.data : 'Failed to update Day 1 attendance.');
                setErrorMessage(msg);
                setErrorDialog(true);
                if (toast.current) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Oops! Something Went Wrong!', life: 3000 });
                }
            });
    };

    const makeParticipantDayTwoPresent = (Id, UserName) => {
        axios.put('/api/Participant/UpdateParticipantOnQrScan', {
            id: Id,
            DayTwoPresent: true,
            VenueDay2ScannedBy: UserName
        })
            .then(res => {
                setSuccessDialog(true);
            }).catch((error) => {
                setIsLoading(false);
                const msg = error?.response?.data?.message || (typeof error?.response?.data === 'string' ? error.response.data : 'Failed to update Day 2 attendance.');
                setErrorMessage(msg);
                setErrorDialog(true);
                if (toast.current) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Oops! Something Went Wrong!', life: 3000 });
                }
            });
    };

    // Modern Button Footers for Dialogs
    const successFooter = (
        <div className="flex justify-content-center pb-2 pt-1">
            <Button
                label="OK"
                icon="fa fa-check"
                className="p-button-primary px-4 py-2 font-bold"
                style={{
                    borderRadius: "8px",
                    fontWeight: "700",
                    minWidth: "120px",
                    fontSize: "0.9rem",
                    backgroundColor: "rgb(42, 102, 151)",
                    borderColor: "rgb(42, 102, 151)",
                    boxShadow: "0 2px 6px rgba(42, 102, 151, 0.25)"
                }}
                onClick={() => { setSuccessDialog(false); history.push('/home/qrscanner'); }}
                autoFocus
            />
        </div>
    );

    const warningFooter = (
        <div className="flex justify-content-center pb-2 pt-1">
            <Button
                label="OK"
                icon="fa fa-check"
                className="p-button-warning px-4 py-2 font-bold"
                style={{
                    borderRadius: "8px",
                    fontWeight: "700",
                    minWidth: "120px",
                    fontSize: "0.9rem",
                    boxShadow: "0 2px 6px rgba(217, 119, 6, 0.25)"
                }}
                onClick={() => {
                    setAirportWarningDialog(false);
                    setHotelWarningDialog(false);
                    setVenueWarningDialog(false);
                    history.push('/home/qrscanner');
                }}
                autoFocus
            />
        </div>
    );

    const errorFooter = (
        <div className="flex justify-content-center pb-2 pt-1">
            <Button
                label="OK"
                icon="fa fa-check"
                className="p-button-danger px-4 py-2 font-bold"
                style={{
                    borderRadius: "8px",
                    fontWeight: "700",
                    minWidth: "120px",
                    fontSize: "0.9rem",
                    boxShadow: "0 2px 6px rgba(220, 38, 38, 0.25)"
                }}
                onClick={() => { setErrorDialog(false); history.push('/home/qrscanner'); }}
                autoFocus
            />
        </div>
    );

    // Redesigned Modal Header Badges (Compact & clean for mobile & desktop)
    const Successheadertemplate = () => {
        return (
            <div className="flex flex-column align-items-center justify-content-center w-full pt-2">
                <div
                    className="flex align-items-center justify-content-center border-circle"
                    style={{
                        width: "52px",
                        height: "52px",
                        backgroundColor: "#dcfce7",
                        border: "3px solid #f0fdf4",
                        boxShadow: "0 0 0 4px rgba(187, 247, 208, 0.4)",
                    }}
                >
                    <i className="fa fa-check" style={{ fontSize: "1.6rem", color: "#16a34a" }}></i>
                </div>
            </div>
        );
    };

    const Warningheadertemplate = () => {
        return (
            <div className="flex flex-column align-items-center justify-content-center w-full pt-2">
                <div
                    className="flex align-items-center justify-content-center border-circle"
                    style={{
                        width: "52px",
                        height: "52px",
                        backgroundColor: "#fef3c7",
                        border: "3px solid #fef9c3",
                        boxShadow: "0 0 0 4px rgba(254, 240, 138, 0.45)",
                    }}
                >
                    <i className="fa fa-exclamation-triangle" style={{ fontSize: "1.6rem", color: "#d97706" }}></i>
                </div>
            </div>
        );
    };

    const Errorheadertemplate = () => {
        return (
            <div className="flex flex-column align-items-center justify-content-center w-full pt-2">
                <div
                    className="flex align-items-center justify-content-center border-circle"
                    style={{
                        width: "52px",
                        height: "52px",
                        backgroundColor: "#fee2e2",
                        border: "3px solid #fef2f2",
                        boxShadow: "0 0 0 4px rgba(254, 202, 202, 0.45)",
                    }}
                >
                    <i className="fa fa-times" style={{ fontSize: "1.6rem", color: "#dc2626" }}></i>
                </div>
            </div>
        );
    };

    const renderParticipantCard = () => {
        if (!participantdata.fullName && !participantdata.company) return null;

        const specQual = [participantdata.speciality, participantdata.qualification].filter(Boolean).join(" - ");
        const locationStr = [participantdata.statename, participantdata.countryname].filter(Boolean).join(" - ");

        return (
            <div
                className="p-2 mb-2 text-left"
                style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    borderRadius: "10px",
                    boxShadow: "0 1px 4px rgba(0, 0, 0, 0.03)"
                }}
            >
                {/* Header: Name (Left) + Designation Badge (Right) */}
                <div
                    className="flex align-items-center justify-content-between flex-wrap gap-1 pb-1 mb-2"
                    style={{ borderBottom: "1px solid #e2e8f0" }}
                >
                    <div className="flex align-items-center" style={{ gap: "8px" }}>
                        <i className="fa fa-user-circle text-primary" style={{ fontSize: "1.2rem", flexShrink: 0 }}></i>
                        <span
                            className="font-bold"
                            style={{
                                fontSize: "0.98rem",
                                color: "#0f172a",
                                letterSpacing: "0.2px",
                                wordBreak: "break-word"
                            }}
                        >
                            {participantdata.fullName}
                        </span>
                    </div>

                    {participantdata.designation && (
                        <span
                            className="px-2 py-1 font-bold"
                            style={{
                                backgroundColor: "#e0f2fe",
                                color: "#0369a1",
                                border: "1px solid #bae6fd",
                                borderRadius: "4px",
                                fontSize: "0.68rem",
                                letterSpacing: "0.5px",
                                textTransform: "uppercase",
                                whiteSpace: "nowrap"
                            }}
                        >
                            {participantdata.designation}
                        </span>
                    )}
                </div>

                {/* 2-Column Side-by-Side Details Grid (Compact 2x2 grid fits on all screens) */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "6px"
                    }}
                >
                    {/* Item: Company */}
                    <div
                        className="p-2"
                        style={{
                            background: "#ffffff",
                            borderRadius: "6px",
                            border: "1px solid #edf2f7"
                        }}
                    >
                        <div
                            className="text-500 font-semibold mb-1 flex align-items-center"
                            style={{ gap: "5px", fontSize: "0.7rem" }}
                        >
                            <i className="fa fa-building-o text-primary" style={{ fontSize: "0.82rem" }}></i>
                            <span>Company</span>
                        </div>
                        <div
                            className="font-bold"
                            style={{ color: "#1e293b", fontSize: "0.82rem", wordBreak: "break-word", lineHeight: "1.25" }}
                        >
                            {participantdata.company || "-"}
                        </div>
                    </div>

                    {/* Item: Speciality - Qualification */}
                    <div
                        className="p-2"
                        style={{
                            background: "#ffffff",
                            borderRadius: "6px",
                            border: "1px solid #edf2f7"
                        }}
                    >
                        <div
                            className="text-500 font-semibold mb-1 flex align-items-center"
                            style={{ gap: "5px", fontSize: "0.7rem" }}
                        >
                            <i className="fa fa-stethoscope text-primary" style={{ fontSize: "0.82rem" }}></i>
                            <span>Speciality</span>
                        </div>
                        <div
                            className="font-bold"
                            style={{ color: "#1e293b", fontSize: "0.82rem", wordBreak: "break-word", lineHeight: "1.25" }}
                        >
                            {specQual || "-"}
                        </div>
                    </div>

                    {/* Item: Location */}
                    <div
                        className="p-2"
                        style={{
                            background: "#ffffff",
                            borderRadius: "6px",
                            border: "1px solid #edf2f7"
                        }}
                    >
                        <div
                            className="text-500 font-semibold mb-1 flex align-items-center"
                            style={{ gap: "5px", fontSize: "0.7rem" }}
                        >
                            <i className="fa fa-map-marker text-red-500" style={{ fontSize: "0.82rem" }}></i>
                            <span>Location</span>
                        </div>
                        <div
                            className="font-bold"
                            style={{ color: "#1e293b", fontSize: "0.82rem", wordBreak: "break-word", lineHeight: "1.25" }}
                        >
                            {locationStr || "-"}
                        </div>
                    </div>

                    {/* Item: Mobile */}
                    <div
                        className="p-2"
                        style={{
                            background: "#ffffff",
                            borderRadius: "6px",
                            border: "1px solid #edf2f7"
                        }}
                    >
                        <div
                            className="text-500 font-semibold mb-1 flex align-items-center"
                            style={{ gap: "5px", fontSize: "0.7rem" }}
                        >
                            <i className="fa fa-phone text-green-600" style={{ fontSize: "0.82rem" }}></i>
                            <span>Mobile No</span>
                        </div>
                        <div
                            className="font-bold"
                            style={{ color: "#1e293b", fontSize: "0.82rem", wordBreak: "break-word", lineHeight: "1.25" }}
                        >
                            {participantdata.mobileno || "-"}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const isAnyDialogOpen = SuccessDialog || AirportWarningDialog || HotelWarningDialog || VenueWarningDialog || ErrorDialog;

    return (
        <div className="flex justify-content-center align-items-center" style={{ minHeight: "calc(100vh - 120px)", padding: "1rem" }}>
            <Toast ref={toast} />

            {!isAnyDialogOpen && (
                <div className="card text-center p-4 border-round-xl shadow-2" style={{ maxWidth: "480px", width: "100%", background: "#ffffff" }}>
                    <div className="mb-3">
                        <i className="fa fa-qrcode" style={{ fontSize: "3.5rem", color: "rgb(42, 102, 151)" }}></i>
                    </div>
                    <h4 className="font-bold mb-2" style={{ color: "rgb(42, 102, 151)" }}>
                        QR Code Verification
                    </h4>
                    {isLoading ? (
                        <div className="my-4">
                            <i className="fa fa-spinner fa-spin fa-2x text-primary mb-2"></i>
                            <p className="text-600 font-medium">Verifying participant details...</p>
                        </div>
                    ) : (
                        <p className="text-600 font-medium mb-3">
                            {participantdata.fullName ? `Participant: ${participantdata.fullName}` : "Processing attendance..."}
                        </p>
                    )}
                    <Button label="Scan Another QR" icon="fa fa-arrow-left" className="p-button-outlined mt-2" onClick={() => history.push('/home/qrscanner')} />
                </div>
            )}

            {/* Redesigned Success Dialog Modal */}
            <Dialog
                closable={false}
                header={Successheadertemplate}
                draggable={false}
                visible={SuccessDialog}
                className="admin-dialog"
                onHide={() => { setSuccessDialog(false); history.push('/home/qrscanner'); }}
                footer={successFooter}
                style={{ width: "460px", maxWidth: "95vw" }}
                breakpoints={{ '960px': '80vw', '640px': '95vw' }}
            >
                <div className="text-center px-1 pt-1">
                    <h4 className="font-bold mb-2" style={{ color: "rgb(42, 102, 151)", fontSize: "1.05rem", lineHeight: "1.3" }}>
                        {userRole === "AIRPORT CO-ORDINATOR" ? (
                            "QR Code Accepted. Airport Check-In Complete."
                        ) : userRole === "HOTEL CO-ORDINATOR" ? (
                            "QR Code Accepted. Check-In Successful. Welcome to your hotel!"
                        ) : (
                            `Scan Complete! ${isDayTwo ? "Day-2" : "Day-1"} Attendance Status: Present.`
                        )}
                    </h4>

                    {renderParticipantCard()}
                </div>
            </Dialog>

            {/* Redesigned Airport Warning Dialog Modal */}
            <Dialog
                closable={false}
                header={Warningheadertemplate}
                draggable={false}
                visible={AirportWarningDialog}
                className="admin-dialog"
                onHide={() => { setAirportWarningDialog(false); history.push('/home/qrscanner'); }}
                footer={warningFooter}
                style={{ width: "460px", maxWidth: "95vw" }}
                breakpoints={{ '960px': '80vw', '640px': '95vw' }}
            >
                <div className="text-center px-1 pt-1">
                    <h4 className="font-bold mb-2" style={{ color: "#c2410c", fontSize: "1.05rem", lineHeight: "1.3" }}>
                        Double Scan Alert: Airport Check-In Already Noted.
                    </h4>

                    {renderParticipantCard()}
                </div>
            </Dialog>

            {/* Redesigned Hotel Warning Dialog Modal */}
            <Dialog
                closable={false}
                header={Warningheadertemplate}
                draggable={false}
                visible={HotelWarningDialog}
                className="admin-dialog"
                onHide={() => { setHotelWarningDialog(false); history.push('/home/qrscanner'); }}
                footer={warningFooter}
                style={{ width: "460px", maxWidth: "95vw" }}
                breakpoints={{ '960px': '80vw', '640px': '95vw' }}
            >
                <div className="text-center px-1 pt-1">
                    <h4 className="font-bold mb-2" style={{ color: "#c2410c", fontSize: "1.05rem", lineHeight: "1.3" }}>
                        Already Checked In. Enjoy Your Accommodation!
                    </h4>

                    {renderParticipantCard()}
                </div>
            </Dialog>

            {/* Redesigned Venue Warning Dialog Modal */}
            <Dialog
                closable={false}
                header={Warningheadertemplate}
                draggable={false}
                visible={VenueWarningDialog}
                className="admin-dialog"
                onHide={() => { setVenueWarningDialog(false); history.push('/home/qrscanner'); }}
                footer={warningFooter}
                style={{ width: "460px", maxWidth: "95vw" }}
                breakpoints={{ '960px': '80vw', '640px': '95vw' }}
            >
                <div className="text-center px-1 pt-1">
                    <h4 className="font-bold mb-2" style={{ color: "#c2410c", fontSize: "1.05rem", lineHeight: "1.3" }}>
                        Double Scan Alert: Attendance Already Noted.
                    </h4>

                    {renderParticipantCard()}
                </div>
            </Dialog>

            {/* Redesigned Error / Fail Dialog Modal */}
            <Dialog
                closable={false}
                header={Errorheadertemplate}
                draggable={false}
                visible={ErrorDialog}
                className="admin-dialog"
                onHide={() => { setErrorDialog(false); history.push('/home/qrscanner'); }}
                footer={errorFooter}
                style={{ width: "460px", maxWidth: "95vw" }}
                breakpoints={{ '960px': '80vw', '640px': '95vw' }}
            >
                <div className="text-center px-1 pt-1">
                    <h4 className="font-bold mb-2 text-red-600" style={{ fontSize: "1.05rem", lineHeight: "1.3" }}>
                        {errorMessage || "Invalid QR Code or participant not found."}
                    </h4>
                    <p className="font-medium text-600 text-xs mb-2">Please try scanning again.</p>

                    {renderParticipantCard()}
                </div>
            </Dialog>
        </div>
    );
};

export default QrScan;